import axios from 'axios'
import { useContext, useState } from 'react'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { FeatureContext } from '../../context api/Features/FeatureContext'
import { CategoryContext } from '../../context api/Category/CategoryContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { bulkUploadPopup, toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, ROUTES, success } from '../../shared/constants'
import { useHistory } from 'react-router'
import { useAuthentication } from '../Authentication/useAuthentication'
import urlSearchParams from '../../components/urlSearchParams'

export const useCategory = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const [category, setCategory] = useState(false)
  const history = useHistory()
  const { addNewCategory, editNewCategory, deleteNewCategory, getNewCategories } = useContext(CategoryContext)
  const { fileUpload, fileUrl } = useAuthentication()
  const [loading, setLoading] = useState(false)

  //CATEGORY
  const getAllCategories = (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_ALL_CATEGORIES(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        getNewCategories(data.data)

        //  false, loading: false })
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getCategory = (dto) => {
    setLoading(true)
    axios
      .post(API.GET_CATEGORY, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setCategory(data.category)

        //  false, loading: false })
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const addCategory = async (dto) => {
    setLoading(true)
    // await fileUpload({file:dto.image})
    await axios
      .post(API.ADD_CATEGORY, dto, header)
    .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Category Added Successfully', success)
        history.push(ROUTES.CATEGORIES)
        // addNewCategory(data.category)
        // setLoading(true)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const updateCategory = async (data) => {
    setLoading(true)
    axios
      .put(API.EDIT_CATEGORY, data, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Category Updated Successfully', success)
        history.push(ROUTES.CATEGORIES)

        // setLoading(true)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const deleteCategory = async (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_CATEGORY, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Category Deleted Successfully', success)
        //console.log(dto)
        deleteNewCategory(dto.categoryId)
        setSelected([])
        // setLoading(true)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const deleteManyCategory = async (dto, setSelected) => {
    setLoading(true)
    //console.log('DTO : ', dto)
    axios
      .post(API.DELETE_MANY_CATEGORY, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage(`${dto.categoryId.length} Category Deleted Successfully`, success)

        dto.categoryId.map((item) => deleteNewCategory(item))
        setSelected([])
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const BulkUpload = async (dto) => {
    setLoading(true)
    axios
      .post(API.BULK_UPLOAD, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }

        bulkUploadPopup(data, addNewCategory)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  return {
    getAllCategories,
    deleteCategory,
    getCategory,
    // product,
    addCategory,
    updateCategory,
    deleteManyCategory,
    BulkUpload,
    category,
    loading,
  }
}
